<template>
  <PageContent>
    <StepsV2 />
    <PanelV2
      type="w6"
      title="Enter your additional details"
      @nextClick="commitData()"
    >
      <template v-slot:title-solt>
        <BdoProgress  :step="2" :total="2"/>
      </template>
      <template v-slot:content-solt>
        <AppForm
          ref="appForm"
          v-model="formData"
          :selectOptions="selectOptions"
         />
      </template>
    </PanelV2>
  </PageContent>
</template>

<script>
  import AppForm from "../forms/SolePropE.val";
  import API from "@/api";
  import {
    // birthCountryOptions,
    citizenShipOptions,
  } from "../../locales/select-data";
  import cityData from "../../common-data/city_select_data";

  export default {
    name: 'IndividualE',
    pRouter: 'IndividualD',
    components: {
      AppForm,
    },
    data() {
      return {
        formData: {},
        selectOptions: {
          countryOfBirth: citizenShipOptions,
          cityOfBirth: cityData,
          citizenship: citizenShipOptions,
        },
      }
    },
    watch: {
      "formData.countryOfBirth": function(val) {
        this.$set(this.formData, 'cityOfBirth', '')
        if(val !== 'Philippines'){
          this.selectOptions.cityOfBirth = [{
            "label": "Others",
            "value": "Others"
          },]
        }else{
          this.selectOptions.cityOfBirth = cityData
        }
      }
    },
    methods: {
      commitData() {

        this.$refs.appForm.$refs.appForm.validate((valid) => {

          if (valid) {
            // console.log(this.formData.birthday,"this.formData.birthday")
            const [year, month, day] = this.formData.birthday.split('-')
            const data = this.formatCommitData({...this.formData, year, month, day})
            delete data.additionalDetails.birthday
            API.addBdoProcess({
              ...data,
            }).then(res => {
              if (res.success) {
                this.toNext()
              }
            })
          }
        });
      }
    }
  }
</script>


<style lang="scss">
.el-form.SolePropE {
  margin-bottom: 22px !important;
}
</style>
